// 节流时间间隔
// eslint-disable-next-line no-magic-numbers
var THROTTLE_DELAY_MS = 1000 * 60 * 5;

export { THROTTLE_DELAY_MS };
